export const TASKS_ADMIN_PATH = "/tasks/administration";
